import { useNavigate } from '@tanstack/react-router';
import { useFirebase } from '@/firebase';
import { useNovel } from '@/context/novel-context';
import { useSubscription } from '@/hooks/useSubscription';
import type { CreateNovelParams } from '@/backend/contracts/novel';

type CreateNovelInput = Omit<CreateNovelParams, 'ownerId' | 'canCreateAIImages'>;

export function useCreateNovel() {
  const { auth, backend } = useFirebase();
  const { setSelectedNovelId } = useNovel();
  const { hasFeature } = useSubscription();
  const navigate = useNavigate();

  const createNovel = async (params: CreateNovelInput) => {
    if (!backend || !auth?.currentUser || !params.title.trim()) return null;

    const canCreateAIImages = hasFeature('can_create_ai_images');
    const novelId = await backend.novels.createNovel({
      ...params,
      ownerId: auth.currentUser.uid,
      canCreateAIImages
    });

    if (novelId) {
      setSelectedNovelId(novelId);
      navigate({ to: '/' });
      return novelId;
    }

    return null;
  };

  return { createNovel };
}
